<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h5>Search Results</h5>
      </div>
    </div>
    <div style="max-height: 300px; overflow-y: scroll; background-color: #fff">
      <table class="table table-striped text-center">
        <thead>
          <tr>
            <th class="text-center"></th>
            <th class="hidden-xs text-center">NPI</th>
            <th class="text-center">Name</th>
            <th class="text-center">Address</th>
          </tr>
        </thead>
        <tbody class="npiListTable">
          <template v-if="loading">
            <tr>
              <td class="text-center" colspan="4">
                <img src="/build/img/loading.gif" width="75" height="75" />
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td>
                <input
                  id="noNPI"
                  v-model="checked_npi"
                  type="radio"
                  name="npiData"
                  class="npiDataRadio"
                  value="none"
                  required="required"
                  @change="check($event)"
                />
              </td>
              <td id="npi_default_text" class="text-left" colspan="3">
                <label for="noNPI">
                  I am not a medical professional or have not been issued an NPI
                  number
                </label>
              </td>
            </tr>
          </template>
          <template v-if="!loading">
            <tr v-for="record in npiResults" :key="`record-${record.number}`">
              <td>
                <input
                  v-model="checked_npi"
                  type="radio"
                  class="npiDataRadio"
                  name="npiData"
                  :value="getRecordValue(record)"
                  @change="check($event)"
                />
              </td>
              <td class="hidden-xs">
                <small>{{ record.number }}</small>
              </td>
              <td>
                <small>
                  {{ record.name }}
                  <span class="hidden visible-xs">
                    NPI: {{ record.number }}
                  </span>
                </small>
              </td>
              <td>
                <small>
                  {{ record.address_1 }} {{ record.address_2 }}
                  <br />
                  {{ record.city }} , {{ record.state }}
                  {{ record.postal_code }}
                </small>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked_npi: this.checked_npi,
    };
  },
  computed: {
    loading() {
      return this.$store.state.registration.loading;
    },
    npiResults() {
      return this.$store.state.registration.npi_results;
    },
  },
  methods: {
    check(event) {
      this.$store.dispatch("setNpiChecked", true);
      this.$store.dispatch("setNpiInfo", event.target.value);
    },
    getRecordValue(record) {
      return `${record.number}|${record.name}|${record.phone}|${record.enumeration_type}`;
    },
  },
};
</script>
